// extracted by mini-css-extract-plugin
export default {"canvasHolder":"main-scene_canvasHolder__zfOim","btn":"main-scene_btn__ey0Yy","uiHolder":"main-scene_uiHolder__FQHy0","textSection":"main-scene_textSection__EJsAD"};